import * as React from 'react'
import classNames from 'classnames'

import { Text, TextName } from '../../sdk/text/Text'
import { Button } from '../../sdk/button/Button'
import classes from './style.module.scss'

interface ComponentProps {
  icon?: string
  text?: string | React.ReactNode
  column?: boolean
  row?: boolean
  className?: string
  buttonText?: string
  onButtonClick?: () => void
  href?: string
  target?: string
}

export const ProductFeatureCard: React.FC<ComponentProps> = (props) => {
  const {
    icon,
    text,
    column = false,
    row = false,
    className,
    buttonText,
    onButtonClick,
    href,
    target,
  } = props

  return (
    <div className={classNames(classes.container, className)}>
      <div className={classNames(
        classes.content,
        column && classes.column,
        row && classes.row
      )}>
        {icon && (
          <img src={icon} alt="" className={classes.icon} />
        )}
        {text && (
          <Text type={TextName.Text} className={classes.text}>
            {text}
          </Text>
        )}
      </div>
      {buttonText && (href || onButtonClick) && (
        <Button
          as={href ? "link" : "button"}
          href={href}
          target={target}
          onClick={onButtonClick}
          className={classes.button}
        >
          {buttonText}
        </Button>
      )}
    </div>
  )
}